import styled from "styled-components";

import ArrowIcon from '../../../images/arrow_icon.svg';

export const Container = styled.form`
  display: flex;
  margin: 0;
  font-size: 11px;
  font-weight: 400;
  align-self: flex-end;

  .provinceSelect {
    text-indent: -9999px;
    position: absolute;
  }

  select {
    border: none;
    padding: 0 10px;
    -webkit-appearance: none;
    -moz-appearance: none;
    background: url(${ArrowIcon}) no-repeat transparent;
    background-size: 8px;
    background-position: 100% center;
    letter-spacing: 1.3px;
    position: relative;
    z-index: 1;
    cursor: pointer;
  }
`;
